import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcError32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m16 2c7.719 0 14 6.281 14 14s-6.281 14-14 14-14-6.281-14-14 6.281-14 14-14zm0 2c-6.625 0-12 5.375-12 12s5.375 12 12 12 12-5.375 12-12-5.375-12-12-12zm0 5c-.563 0-1 .437-1 1v7.75c0 .594.469 1 1 1 .563 0 1-.437 1-1v-7.75c0-.75-.563-1-1-1zm0 14.344c-.719 0-1.344-.625-1.344-1.344 0-.75.625-1.344 1.344-1.344.75 0 1.344.594 1.344 1.344 0 .719-.594 1.344-1.344 1.344z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcError32;
